<script>
  import List from "$lib/components/List.svelte";
  import ListItemBasic from "$lib/components/ListItemBasic.svelte";
  import Pagination, { paginateItems } from "$lib/components/Pagination/Pagination.svelte";
  import SearchBar from "$lib/components/SearchBar.svelte";
  import Bleed from "./Bleed.svelte";

  export let title;
  export let description;
  export let searchBarPlaceholder = "";
  export let items = [];
  export let itemComponent = ListItemBasic;
  export let itemsPerPage = 10;
  export let maxNavigatablePages = 5;
  export let formName;
  export let containerRef;
  export let errorId;
  export let errorMessage;
  export let handleClear;

  $: ({ numOfPages, paginatedItems } = paginateItems(items, itemsPerPage));
  $: activeItems = paginatedItems?.[0] ?? [];
  function onNavigate(event) {
    activeItems = paginatedItems[event.detail.page - 1];
    window.scrollTo({
      top: containerRef?.offsetTop || 0,
      behavior: "smooth"
    });
  }
</script>

<div bind:this={containerRef} class="w-full md:w-3/5 lg:w-806 m-auto">
  <p class="text-size-32 font-bold py-32 md:text-left sm:text-center">{title}</p>
  <SearchBar
    placeholder={searchBarPlaceholder}
    on:submit
    formFieldName={`${formName}-searchableList`}
    {handleClear}
  />
  <div aria-live="polite" aria-atomic="true">
    {#if errorMessage}
      <p id={errorId} class="text-error text-size-12 mt-8">
        {errorMessage}
      </p>
    {/if}
  </div>
  <List {description} items={activeItems} component={itemComponent} />
</div>

<Bleed fullWidth={true}>
  <Pagination
    numOfItems={items?.length}
    {numOfPages}
    {itemsPerPage}
    {maxNavigatablePages}
    on:navigate={onNavigate}
    class="w-auto mx-auto md:pt-72 pt-48"
  />
</Bleed>
